
<template>
 <zm-drawer :footer="false" size="large" :title="title" :width="drawerWidth" :visible="visible" @cancel="open(false)">
    <div slot="drawerBody">
    <a-form :form="form">
      <a-row>
      <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="应用名词"
              hasFeedback
            >
            <div class="text">{{model.appName||'暂无'}}</div>
            </a-form-item>
           </a-col>
            <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="账号"
              hasFeedback
            >
            <div class="text">{{model.accountId||'暂无'}}</div>
            </a-form-item>
           </a-col>
            <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="密钥"
              hasFeedback
            >
            <div class="text">{{model.authToken||'暂无'}}</div>
            </a-form-item>
           </a-col>
            <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="IP地址"
              hasFeedback
            >
            <div class="text">{{model.ip||'暂无'}}</div>
            </a-form-item>
           </a-col>
            <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="端口"
              hasFeedback
            >
            <div class="text">{{model.port||'暂无'}}</div>
            </a-form-item>
           </a-col>
            <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="扫描接口"
              hasFeedback
            >
            <div class="text">{{model.scanUrl||'暂无'}}</div>
            </a-form-item>
           </a-col>
            <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="文件获取接口"
              hasFeedback
            >
            <div class="text">{{model.getUrl||'暂无'}}</div>
            </a-form-item>
           </a-col>
            
      </a-row> 
    </a-form>
  </div>
  </zm-drawer>
</template>
<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { mapState } from 'vuex'

export default {
  name: 'editFps',
  mounted () {
    
  },
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth () {
      const width = window.innerWidth - 200
      return width
    },
    ...mapState({
      
    })
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'fps' }),
      visible: false,
      defaultModel: {},
      model: {
        
    accountId : '',
    authToken : '',
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 }
      },
      colSpan:12,
      
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if ((this.type === this.$sysInfo.MODAL_MODIFY) || (this.type === this.$sysInfo.MODAL_VIEW)) {
        if(flag){
          // this.getModelInfo(this.model) 通过接口获取详情
        }
      }
    },
    // 清空表单
    formClear () {
       this.form.setFieldsValue({appName: '',ip: '',port: '',scanUrl: '',getUrl: '',})
      
      this.model.accountId= ''
      this.model.authToken= ''
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 获取select列表
   
  },
}
</script>

<style scoped lang="less">
  .ant-form-item{
    .text,.textArea{
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      padding: 0 10px;
    }
  }
</style>
